<link *ngFor="let layoutFile of layoutFiles; let i = index" rel="preload" as="style" [href]="layoutFile.safeUrl"
  (load)="customCssLoaded(i)" (error)="customCssErrored(i)">
<link *ngFor="let activeLayoutFile of activeLayoutFiles" rel="stylesheet" [href]="activeLayoutFile.safeUrl">
<!-- Assessments block fully offline regardless of admin/banner mode — D3, never cacheable,
     takes priority over the ordinary banner (offline-block-assessment.guard.ts handles the
     navigate-to-it case; this handles already being on one when connectivity drops). -->
<div class="atire" *ngIf="assessmentOfflineBlocked">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>OFFLINE</h1>
    <h4>Assessments need an internet connection. Please reconnect to continue.</h4>
  </div>
</div>
<!-- offlineBannerMode (school-level offline mode on, and this user is not an admin) swaps
     this overlay for the offline-block-overlay below instead. Admins, and every session
     where the feature is off, see this exact overlay unchanged — D5. -->
<!-- !offlineHubRouteAllowed, matching the translucent overlay below. .atire is a full-viewport
     opaque block, so without this it kept covering the downloads hub after the link below had
     navigated there - the outlet rendered underneath and the link looked like it did nothing. -->
<div class="atire" *ngIf="!assessmentOfflineBlocked && !isOnline && !offlineBannerMode && !offlineHubRouteAllowed">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>OFFLINE</h1>
    <h4>Please check your internet connection</h4>
    <!-- Two variants of this same wall: a school with offline saving off has no downloads hub
         to send anyone to, so it gets the plain message only. A school with the feature on
         (offlineFeatureAvailable - the school-level flag, independent of offlineIsAdmin so an
         admin on such a school still sees it) gets the escape hatch below. It depends on
         NOTHING but the URL, which matters because this wall is also what shows when the
         offline session itself could not be resolved - on the downloads page the self-check
         explains what is actually missing. Reaching a page that says "nothing downloaded" is
         recoverable; being sealed behind this wall is not. -->
    <a class="btn m-0 mt-3" *ngIf="offlineFeatureAvailable" routerLink="/user/managedownloads">View downloaded lessons</a>
  </div>
</div>
<!-- Offline mode's blocking overlay (non-admin, offlineBlocked = connState==='offline').
     Confines browsing to the downloads hub instead of trying to keep arbitrary pages working
     offline — offlineHubRouteAllowed is the one exception, or there'd be no way to reach the
     content this overlay points at. Translucent by design (var(--primary-lighter)), unlike
     the opaque admin .atire block above — the two are for different audiences (D5) and
     deliberately look different. -->
<div class="offline-block-overlay" *ngIf="!assessmentOfflineBlocked && offlineBlocked && !offlineHubRouteAllowed">
  <div class="offline-block-overlay__panel">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h3>You're offline</h3>
    <p>Browsing isn't available offline. You can still view anything you've saved.</p>
    <a class="btn m-0" routerLink="/user/managedownloads">Go to downloads</a>
  </div>
</div>
<!-- isSchoolEnabled is null until the school has been fetched, so this must test for
     an explicit false. Testing !isSchoolEnabled showed "SCHOOL DISABLED" whenever the
     lookup had not finished or had failed. -->
<div class="atire" *ngIf="isSchoolEnabled === false && !isNotFoundError && !startupFailed">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>SCHOOL DISABLED</h1>
  </div>
</div>
<div class="atire" *ngIf="isNotFoundError">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>SCHOOL NOT FOUND</h1>
  </div>
</div>
<!-- !offlineHubRouteAllowed: downloads live entirely on the device, so a failed startup must
     never stand between a student and them. Offline, this wall offers the way there, and on
     the hub's own routes it steps aside (the router outlet below lets them render). -->
<div class="atire" *ngIf="startupFailed && !offlineHubRouteAllowed">
  <div class="wrapper">
    <img class="logoImg mb-3" alt="School Logo" [src]="logoUrl" *ngIf="logoUrl" />
    <h1>SOMETHING WENT WRONG</h1>
    <h4>We could not load this page. Please try again in a moment.</h4>
    <button type="button" class="btn mt-3" (click)="retryStartup()">Try again</button>
    <a class="btn mt-3" *ngIf="!isOnline || connState !== 'online'" routerLink="/user/managedownloads">View downloaded lessons</a>
  </div>
</div>
  <!-- offlineHubRouteAllowed is ORed into the connectivity clause deliberately. Without it,
       `isOnline` being false (navigator.onLine, which this codebase elsewhere notes is
       unreliable) removed the router outlet entirely whenever offlineBannerMode was false - so
       no page could render at all, the link above had nothing to navigate to, and a student
       with lessons saved on the device was sealed behind the wall with no way back. The hub,
       its reader and the media frame must always be able to render; they are the only routes
       that work without a connection anyway. -->
  <router-outlet *ngIf="!assessmentOfflineBlocked && (!offlineBlocked || offlineHubRouteAllowed) && (isOnline || offlineBannerMode || offlineHubRouteAllowed) && ((isSchoolEnabled && !startupFailed) || (startupFailed && offlineHubRouteAllowed))"></router-outlet>
<div class="modal fade" id="appComponentConfirmModal" tabindex="-1" role="dialog" aria-hidden="true"
  data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="appComponentConfirmModal_Title"></h3>
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
      </div>
      <div class="modal-body" id="appComponentConfirmModal_Body">

      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" data-dismiss="modal"
          (click)="this.utilservice.confirmYesClicked()">{{this.utilservice.dialogConfirmMode ? "Yes" : "Ok"}}</button>
        <button *ngIf="this.utilservice.dialogConfirmMode" type="button" class="btn btn--warning m-0"
          data-dismiss="modal" (click)="this.utilservice.confirmNoClicked()">No</button>
      </div>
    </div>
  </div>
</div>
<div class="fade modal h-100" id="stripeCheckout" role="dialog" aria-hidden="true"
  data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="appComponentConfirmModal_Body">
            <div id="checkout"></div>
      </div>
     
    </div>
  </div>
</div>